<template>
  <div>
    <el-radio-group v-model="request" @change="optRequest()">
      <el-radio-button label="0">全部</el-radio-button>
      <el-radio-button label="1">未結單</el-radio-button>
      <el-radio-button label="2">已結單</el-radio-button>
    </el-radio-group>
  </div>
</template>

<script>
export default {
  props: {
    enterpriseId: Number,
    invoiceType: String,
  },
  data() {
    return {
      request: 0,
    }
  },
  methods: {
    optRequest() {
      if (this.invoiceType !== 'all' && this.enterpriseId === 0) {
        this.request = 0
      }
      this.$emit('optRequest', this.request)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/element_ui/RequestRadioButton.vue